var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineConnector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 835,
    height: 190,
    viewBox: "0 0 835 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 169.32V93.1873V8.25069L198.382 1L416.251 189L641.615 4.10744H834V169.32",
    stroke: "#FFBB0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineConnector);
export default __webpack_public_path__ + "static/media/line-connector.2066e693193d62db1eb218f0aca391ff.svg";
export { ForwardRef as ReactComponent };